
import {useCallback} from 'react'
import Globals from 'system/Globals'
import { openLink } from 'system/utils/linkHandler'
import history from 'system/navigation/MainRouterHistory'
import gsap, {Power3} from 'gsap'

function goToNarrativeLink(link, module_id, socket, socketPrefs) {

    let moduleId = link.split("module=");
    let narrativeId = link.split("narrative=");
    let slideId = link.split("slide=");
    if (narrativeId[1]) {
        let narrativeTarget = narrativeId[1];
        let narrativeParams = narrativeTarget.split('?');
        let narrativeIdTarget = narrativeParams[0];

        console.log('goToNarrativeLink', narrativeIdTarget)

        setTimeout(()=>{
            if (socketPrefs && socketPrefs.mode === "isBroadcast") {
                socket.emit('cast', [socketPrefs.room, 'nav#path=' + narrativeIdTarget]);
                console.log('nav#path=', narrativeIdTarget)
            }
        },300)
    } else if (moduleId[1]) {
        console.log('set current params' + link)
        setTimeout(()=>{
            if (socketPrefs && socketPrefs.mode === "isBroadcast") {
                socket.emit('cast', [socketPrefs.room, 'nav#path=' + link]);
                socket.emit('cast', [socketPrefs.room, 'narrative-module-id#link=' + link]);
                console.log("broadcast button", 'narrative-module-id#path=' + link)
            }
        },300)
    } else if (slideId[1]) {
        // placeholder
    } else {
        console.log('no link found')
    }
}

/**
 * Hook that returns an onClick handler for interactive components with links.
 *
 * @param {object} opts
 * @param {string} opts.link - The link/action string (e.g. "action=layer&target=29009")
 * @param {object} opts.refEle - Ref to the component's DOM element
 * @param {string} opts.pageId - Current page ID
 * @param {string} opts.nid - Narrative ID
 * @param {array}  opts.flatMenuItems - Flat menu items for slide lookup
 * @param {function} opts.onScrollToEvent - Scroll to page callback
 * @param {function} opts.setCurrentPage - Set current page callback
 * @param {object} opts.socket - Socket.io instance
 * @param {object} opts.socketPrefs - Socket preferences
 * @param {function} [opts.onTargetToggle] - Optional callback for target toggling (receives {target, targetElem, targetElem_arBox, isReset})
 */
function useInteraction(opts) {

    const {
        link,
        refEle,
        pageId,
        nid,
        flatMenuItems,
        onScrollToEvent,
        setCurrentPage,
        socket,
        socketPrefs,
        onTargetToggle
    } = opts

    const onClick = useCallback((e) => {

        e.stopPropagation();

        if (!link) return;

        let url = new URL(window.location.href)
        let urlparams = new URLSearchParams(link)
        let moduleid = urlparams.get("module")
        let slideId = urlparams.get("page")
        let target = urlparams.get("target")
        let toggle = urlparams.get("toggle")

        let locParms = new URLSearchParams(document.location.search);
        let userId = locParms.get("u")

        let pathLink = link;
        let isExternal = pathLink.includes('http') || pathLink.includes('https') || pathLink.includes('mailto');

        if ((Globals.instance().useHashRouter) && (!isExternal)) {
            let path = url.hash.substring(1)
            let arr = path.split('?')
            let search = ''
            if (path.indexOf('?')) {
                path = arr[0]
                search = arr[1]
            }
            search = search ? '&' + link : link + "&landing=false"

            if (moduleid || slideId) {
                document.querySelectorAll('video').forEach(video => { try { if (!video.paused) video.pause(); } catch(err){} });
            }

            if (Globals.instance().ios) {
                history.push({pathname: path, hash: search + "&back=" + pageId, search: '?' + search + "&back=" + pageId})
            } else {
                history.push({pathname: path, search: '?' + search + "&back=" + pageId})
            }

            if (socketPrefs && socketPrefs.mode === "isBroadcast") {
                goToNarrativeLink(path + search + "&back=" + pageId, null, socket, socketPrefs)
            }

        } else {

            if (isExternal) {
                openLink(link)

            } else {

                let userToken;
                if (userId) {
                    userToken = "u=" + userId + "&";
                }

                if (target) {
                    let targetId = "component_dim_file_" + target;
                    let targetId_arBox = "component_dim_file_arBox_" + target;

                    let targetElem = document.getElementById(targetId)
                        || document.getElementById("component_dim_file_svg_" + target);
                    let targetElem_arBox = document.getElementById(targetId_arBox);
                    let opacity = 1;

                    if (targetElem) {
                        let opacityStart = targetElem.dataset.opacity;
                        let opacityCurr = targetElem.style.opacity;
                        let innerElem = targetElem.querySelector('.arBoxInner');

                        if (opacityCurr !== opacityStart) {
                            gsap.to(targetElem, {duration: 0.35, ease: Power3.easeInOut, opacity: opacityStart, pointerEvents: "auto"})
                            if (targetElem_arBox) gsap.to(targetElem_arBox, {duration: 0.35, ease: Power3.easeInOut, opacity: opacityStart, pointerEvents: "auto"})
                            if (innerElem) gsap.to(innerElem, {duration: 0.35, ease: Power3.easeInOut, opacity: opacityStart})
                            if (onTargetToggle) onTargetToggle({target, targetElem, targetElem_arBox, isReset: true})
                        } else {
                            gsap.to(targetElem, {duration: 0.35, ease: Power3.easeInOut, opacity: opacity, pointerEvents: "auto"})
                            if (targetElem_arBox) gsap.to(targetElem_arBox, {duration: 0.35, ease: Power3.easeInOut, opacity: opacity, pointerEvents: "auto"})
                            if (innerElem) gsap.to(innerElem, {duration: 0.35, ease: Power3.easeInOut, opacity: opacity})
                            if (onTargetToggle) onTargetToggle({target, targetElem, targetElem_arBox, isReset: false})
                        }

                        if (toggle && toggle === '1') {
                            gsap.to(refEle.current, {duration: 0.35, ease: Power3.easeInOut, opacity: 0})
                            gsap.to(refEle.current, {duration: 0, pointerEvents: "none"})
                        }

                        // If the target element contains a video with autoplay attribute, reset and play it
                        const videoElem = targetElem.querySelector('video');
                        if (videoElem && videoElem.hasAttribute('data-auto')) {
                            videoElem.currentTime = 0;
                            videoElem.play();
                        }
                    }
                }

                if (slideId) {
                    let pageIndex = flatMenuItems.findIndex(o => o.page === parseInt(slideId))
                    onScrollToEvent(parseInt(slideId), 'fade')
                    setCurrentPage(pageIndex)
                }

                if (moduleid) {
                    let search;
                    if (userToken) {
                        search = userToken + link + "&back=" + pageId;
                    } else {
                        search = link + "&back=" + pageId;
                    }
                    if (url.pathname.indexOf('C:/') > -1) {
                        url.pathname = url.pathname.replace('C:/', '');
                    }
                    let pathname = url.pathname;
                    if (Globals.instance().ios && !Globals.instance().useLocal && nid) {
                        pathname = '/narrative/' + nid
                    }
                    if (moduleid || slideId) {
                        document.querySelectorAll('video').forEach(video => { try { if (!video.paused) video.pause(); } catch(err){} });
                    }
                    history.push({pathname: pathname, search: '?' + search})

                    if (socketPrefs && socketPrefs.mode === "isBroadcast") {
                        goToNarrativeLink(url.pathname + link, moduleid, socket, socketPrefs)
                    }
                }
            }
        }

        if (moduleid) {
            refEle.current.dispatchEvent(new CustomEvent('narrative-pop-up', { detail: {typeName: "module", module: moduleid}, bubbles: true}))
        }

    }, [refEle, link, pageId, nid, flatMenuItems, onScrollToEvent, setCurrentPage, socket, socketPrefs, onTargetToggle])

    return onClick
}

export {useInteraction}
